var EButtonSize;

(function (EButtonSize) {
  EButtonSize["small"] = "small";
  EButtonSize["medium"] = "medium";
  EButtonSize["large"] = "large";
})(EButtonSize || (EButtonSize = {}));

var EButtonVariant;

(function (EButtonVariant) {
  EButtonVariant["primary"] = "primary";
  EButtonVariant["secondary"] = "secondary";
  EButtonVariant["tertiary"] = "tertiary";
  EButtonVariant["prio"] = "prio";
  EButtonVariant["ghost"] = "ghost";
})(EButtonVariant || (EButtonVariant = {}));

export { EButtonSize, EButtonVariant };